import { render, staticRenderFns } from "./GiveSuccess.vue?vue&type=template&id=e9d75166&scoped=true&"
import script from "./GiveSuccess.vue?vue&type=script&lang=js&"
export * from "./GiveSuccess.vue?vue&type=script&lang=js&"
import style0 from "./GiveSuccess.vue?vue&type=style&index=0&id=e9d75166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d75166",
  null
  
)

export default component.exports